<template>

<v-container fluid fill-height>
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <v-layout v-else column>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="primary" class="white--text">
                    <v-toolbar-title>Public Holidays</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon dark>today</v-icon>
                </v-toolbar>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-alert :value="error != null" outline type="error">
                            {{error}}
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn color="primary" block  @click="showEditAddAttribute({ UserDefined: true })">
                            Add
                        </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm3 offset-sm1>
                        <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
                    </v-flex> -->
                </v-layout>
                <v-layout pt-3>
                    <v-flex xs12>
                        <holiday-settings :holidays="holidays" @edit="showEditAddAttribute($event)" ></holiday-settings>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog 
        :value="editing"
        fullscreen 
        hide-overlay 
        transition="dialog-bottom-transition">
        <holiday-add-edit 
            v-if="editing"
            :item="editItem"
            @cancel="cancelEdit()"
            :options="regions"
            :submitLoading="loading"
            :submitError="submitError"
            @submit="handleSubmit" >
            <!-- -->
        </holiday-add-edit>
    </v-dialog>
</v-container>
</template>

<script>
import HolidaySettings from '@/components/configuration/holidays/PublicHolidaySettings.vue'
import HolidayAddEdit from '@/components/configuration/holidays/PublicHolidayAddEdit.vue'
import HolidayApi from '@/api/holidayApi'
import ConfigurationApi from '@/api/configurationApi'

export default {
  data: function() {
        return {
            error: null,
            loading: false,
            activeOnly: true,
            holidays: [],
            regions: [],
            editing: false,
            editItem: null,
            submitError: null
        }
    },
    computed: {

    },
    methods: {
        async loadHolidays() {
            console.log('load holidays')
            this.loading = true;
            this.error = null;

            Promise.all([
                HolidayApi.getHolidays({}), 
                ConfigurationApi.getRegions()
            ]).then(responses => {
                this.regions = responses[1];
                this.holidays = responses[0];
            }).catch(error => {
                console.log('in the rye', error)
                this.error = error;
            })
            .finally(()=>{
                this.loading = false;
            })

        },
        showEditAddAttribute(item) {
            this.editItem = item;
            this.editing = true;
        },
        cancelEdit() {
            this.editItem = null;
            this.editing = false;
        },
        async handleSubmit(item) {
            this.loading = true;
            console.log('user submitted', item)
            try {
                var result = await HolidayApi.addUpdateHoliday(item)
                if(!result.Success) {
                    throw result.ErrorMessages
                }
                this.editing = false;
                this.loadHolidays();
            }
            catch(err) {
                this.submitError = err;
            }
            finally {
                this.loading = false;
            }
        }
    },
    async created() {
        await this.loadHolidays();
    },
    components: {
        HolidaySettings,
        HolidayAddEdit
    }
}
</script>

<style>

</style>
